import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 26, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.7, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const MaskLines = ({ lines, className = "", lineClassName = "", delay = 0, gradientLast = false }) => (
    <span className={"block " + className}>
        {lines.map((l, i) => {
            const isLast = gradientLast && i === lines.length - 1;
            return (
                <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
                    <motion.span
                        className={"block will-change-transform " + lineClassName}
                        style={isLast ? { color: "transparent", backgroundImage: "linear-gradient(100deg,#41C6F1,#0A5FC2)", WebkitBackgroundClip: "text", backgroundClip: "text" } : undefined}
                        initial={{ y: "112%" }}
                        animate={{ y: "0%" }}
                        transition={{ duration: 0.9, delay: delay + i * 0.13, ease: EASE }}
                    >
                        {l}
                    </motion.span>
                </span>
            );
        })}
    </span>
);

export const FadeIn = ({ children, delay = 0, y = 14, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);
